import React, { useState, useEffect } from 'react';
import { Fab, Zoom } from '@mui/material';
import { KeyboardArrowUp as ArrowUpIcon } from '@mui/icons-material';
import { motion } from 'framer-motion';

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Zoom in={visible}>
      <motion.div
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        style={{ position: 'fixed', bottom: 24, right: 24, zIndex: 1000 }}
      >
        <Fab
          onClick={scrollToTop}
          sx={{
            background: 'linear-gradient(135deg, #0288d1 0%, #4fc3f7 100%)',
            color: 'white',
            boxShadow: '0 4px 20px rgba(79,195,247,0.4)',
            '&:hover': {
              boxShadow: '0 8px 40px rgba(79,195,247,0.6)',
            },
            transition: 'all 0.3s ease',
          }}
        >
          <ArrowUpIcon />
        </Fab>
      </motion.div>
    </Zoom>
  );
};

export default ScrollToTop;
